import styled from 'styled-components';
import { truncateWidth } from 'legacyComponents/styled/styleUtils';

import { PreviewCard } from 'libs/rendering/preview/styles';
import Spinner from 'components/Spinner';

export const FinderColumn = styled.div`
  ${PreviewCard} {
    max-height: 260px;
    border: 1px solid ${props => props.theme.color.wfGrey200};
    overflow: hidden;
    > video {
      width: 100%;
    }
    > img {
      width: 100%;
    }
  }
  min-width: 300px;
  width: 300px;
  border-right: 1px solid ${props => props.theme.color.wfGrey200};
  padding: 6px;
  position: relative;
  overflow: hidden;
`;

export const ColumnList = styled.ul`
  margin-bottom: 0;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
`;

export const ColumnItem = styled.li`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  font-size: 0.95em;
  color: ${props =>
    props.active ? props.theme.color.wfWhite : props.theme.color.wfGrey};
  background-color: ${props =>
    props.active
      ? props.theme.color.primary
      : props.selected
      ? props.theme.color.wfGrey200
      : 'transparent'};
  padding: ${props => (props.active ? '6px 6px 6px 12px' : '6px')};
  margin: 3px 0px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  &:hover {
    background-color: ${props =>
      props.active ? props.theme.color.primary : props.theme.color.wfGrey200};
  }
`;

export const ColumnItemName = styled.span`
  ${truncateWidth('265px')};
`;

export const ColumnItemArrow = styled.div`
  color: ${props =>
    props.active ? props.theme.color.wfWhite : props.theme.color.wfGrey500};
`;

export const FileName = styled.p`
  text-align: center;
  margin: 20px 0px 5px 0px;
`;

export const FileDetails = styled.p`
  font-size: 0.8em;
  text-align: center;
  margin: 0px 0px 20px 0px;
`;

export const EmbedSettingsRow = styled.div`
  position: absolute;
  width: 100%;
  background-color: ${props => props.theme.color.wfGrey100};
  border-top: 1px solid ${props => props.theme.color.wfGrey200};
  bottom: 2px;
  left: 0px;
`;

export const EmbedOptionWrapper = styled.div`
  position: relative;
  padding: 12px;
  border-bottom: ${props =>
    props.first ? `1px solid ${props.theme.color.wfGrey100}` : '0'};
`;

export const EmbedOption = styled.p`
  display: inline-block;
  margin: 0px;
  line-height: 30px;
  font-size: 0.875em;
  font-style: italic;
`;

// Main index.js
export const FinderWrapper = styled.div`
  height: 100%;
  position: relative;
`;

export const PathInputWrapper = styled.div`
  position: relative;
  width: 100%;
  border-bottom: 1px solid ${props => props.theme.color.wfGrey200};
`;

export const SpinnerStyled = styled(Spinner)`
  position: absolute;
  top: 15px;
  right: 10px;
`;

export const PathInput = styled.input`
  max-width: 100%;
  width: 100%;
  font-size: 18px;
  padding: 15px;
  color: #323232;
  background-color: ${props => props.theme.color.wfGrey100};
  border: none;
`;

export const FoldersSection = styled.div`
  display: flex;
`;

export const ColumsWrapper = styled.div`
  height: 550px;
  width: 100%;
  display: flex;
  overflow-x: scroll;
  overflow-y: hidden;
`;
